{
  "partnership_list": {
    "navigation_title": "Asociaciones"
  }
}
